import React, { useMemo } from "react";
import { Trans } from "react-i18next";
import { useSelector } from "react-redux";
import { Caption1 } from "@activecollab/components";
import classnames from "classnames";
import PropTypes from "prop-types";
import { makeShortUserNameSelector } from "~/store/selectors/selector.users.jsx";
import Angie from "~/utils/angie.jsx";
import { useWhoIsWriting } from "./Hooks/index.jsx";

export const TemplateString = ({ userIds }) => {
  const getShortUserName = useMemo(makeShortUserNameSelector, []);

  const firstUser = useSelector((state) => getShortUserName(state, userIds[0] ?? 0));

  const secondUser = useSelector((state) => getShortUserName(state, userIds[1] ?? 0));

  switch (userIds.length) {
    case 1: {
      return (
        <Trans firstUser={firstUser}>
          <b>{{ firstUser }}</b> is typing...
        </Trans>
      );
    }
    case 2: {
      return (
        <Trans
          firstUser={firstUser}
          secondUser={secondUser}
        >
          <b>{{ firstUser }}</b> and <b>{{ secondUser }}</b> are typing...
        </Trans>
      );
    }
    case 3: {
      return (
        <Trans
          firstUser={firstUser}
          secondUser={secondUser}
        >
          <b>{{ firstUser }}</b>, <b>{{ secondUser }}</b> and 1 other are typing...
        </Trans>
      );
    }
    default: {
      const number = userIds.length - 2;
      return (
        <Trans
          firstUser={firstUser}
          secondUser={secondUser}
          number={number}
        >
          <b>{{ firstUser }}</b>, <b>{{ secondUser }}</b> and {{ number }} others are typing...
        </Trans>
      );
    }
  }
};

TemplateString.propTypes = {
  userIds: PropTypes.arrayOf(PropTypes.number),
};

TemplateString.defaultProps = {
  userIds: [],
};

const WhoIsWriting = ({ context, className, ...rest }) => {
  const { userIds } = useWhoIsWriting(context, true);

  return userIds.length ? (
    <span className={classnames("who-is-writing tw-inline-flex tw-items-center", className)}>
      <img
        className="keyboard_image tw-mr-2"
        src={`${Angie.assets_url}/system/images/realtime/keyboard.gif`}
        alt="typing_keyboard"
      />
      <span
        {...rest}
        className="who-is-writing-text"
      >
        <Caption1 color="secondary">
          <TemplateString userIds={userIds} />
        </Caption1>
      </span>
    </span>
  ) : null;
};

WhoIsWriting.propTypes = {
  context: PropTypes.string.isRequired,
  className: PropTypes.string,
};

WhoIsWriting.displayName = `WhoIsWriting`;

export default WhoIsWriting;
